// Single source of truth for turning a raw error message into a stable "signature" used to match it
// to a Knowledge Base entry. Variable parts (UUIDs, numbers) are stripped so errors that differ only
// by id collapse to one signature — e.g.
//   "no target profile synced for source id 22132185 (scopes tried: INDIVIDUALS,CONTACT)"
//   "no target profile synced for source id 22500343 (scopes tried: INDIVIDUALS,CONTACT)"
// both become "no target profile synced for source id # (scopes tried: individuals,contact)".
//
// The frontend computes the signature both when matching an error line to KB and when creating a KB
// entry; the backend just stores/queries the signature string, so there is exactly one implementation.

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
// An UPPER-CASE alphanumeric token that contains at least one digit — i.e. an identifier code such as
// a block code (2607TEAMAM), rate code (GROUP20D), room type (Q1/K1J), property/error code (FOF00097,
// HILTNCU1PR). These are variable, so collapse them to {code} the same way numbers collapse to #, so
// "Missing linked Block 2607TEAMAM" and "Missing linked Block 2608BMENSA" share one KB entry. The
// "contains a digit + is all upper-case" test deliberately leaves meaningful words intact — OHIP,
// INDIVIDUALS, TravelAgent, Company (no digit / mixed case) are kept, and "companyName2" (mixed case)
// still collapses only its digit → "companyname#". Purely-alpha codes (e.g. guarantee code DPRC) are
// NOT collapsed and stay per-code, matching how they are added by hand today.
const CODE_RE = /\b(?=[A-Z0-9]*[A-Z])(?=[A-Z0-9]*[0-9])[A-Z0-9]{2,}\b/g;

export function errorSignature(message) {
    if (!message) return '';
    return String(message)
        .replace(UUID_RE, '{uuid}')       // uuids first (they contain digits)
        .replace(CODE_RE, '{code}')       // identifier codes (run before lower-casing — needs the caps)
        .toLowerCase()
        .replace(/\d+/g, '#')             // any remaining run of digits → #
        .replace(/\s+/g, ' ')             // collapse whitespace
        .trim()
        .slice(0, 500);                   // matches the DB column width
}

export default errorSignature;
